<template>
  <div class="spinner" :style="style" />
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
import { colors } from '@/composables/useColors';

export default defineComponent({
  props: {
    size: {
      type: String,
      default: '2em'
    },

    color: {
      type: String,
      default: 'grey01'
    }
  },

  setup: (props) => {
    const style = computed(() => {
      return {
        width: props.size,
        height: props.size,
        'border-width': `calc(${props.size} * 0.06)`,
        'border-color': colors.common[props.color]
      };
    });

    return {
      style
    };
  }
});
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables';
@use '@/assets/scss/mixin';

.spinner {
  margin: 0 auto;
  border-radius: 50%;
  border-style: solid;
  border-left-color: transparent !important;
  animation: spinner 1.75s linear infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
</style>
